import React from 'react'
import Router from 'next/router'
import { PageSpinner } from 'components/ui'

type Props = {
  authorized: boolean
  fetching: boolean
  children: React.ReactElement
  /** 未認可の場合に表示するフォールバックUI */
  fallback?: React.ReactElement
}

const Component: React.FC<Props> = ({ authorized, fetching, children, fallback }) => {
  if (fetching) return <PageSpinner />

  if (!fetching && !authorized) {
    // 未認可時のフォールバックUIが指定されている場合は、それを表示
    if (fallback) {
      return fallback
    }

    // フォールバックUIが指定されていない場合は、未認可のページにリダイレクト
    Router.replace('/403')
    return null
  }

  return children
}

export default Component
